<section class="delete-confirm-dialog">
  <div class="button-group">
    <div (click)="onClose(DeleteConfirmationOptions.DELETE)" class="btn">
      {{ deleteText | translate }} <span translate>{{ text }}</span>
    </div>
    @if (showReportButton) {
      <div (click)="onClose(DeleteConfirmationOptions.REPORT)" class="btn top-border" translate>messages.report</div>
    }
  </div>

  <div (click)="onClose(DeleteConfirmationOptions.CLOSE)" class="cancel-btn" translate>messages.cancel</div>
</section>
